<template>
	<div class="portlet light bordered">
		<div class="portlet-title">
			<div class="caption uppercase bold">
				Select An Action
			</div>
		</div>
		<div class="mt-element-list mt-element-overflow">
			<div class="mt-list-container list-default no-border">
    			<ul>
    				<li class="mt-list-item" v-for="action in actionsList">
    					<div class="list-icon-container" :class="{'done': action.main_action}">
    						<a @click="emitFunction(action.click_event, action.function_params)">
    							<i :class="action.icon_class"></i>
    						</a>
    					</div>
    					<div class="list-item-content" :class="{'no-description': !action.description}">
    						<h3 class="uppercase bold">
    							<a @click="emitFunction(action.click_event, action.function_params)">{{ action.title }}</a>
    						</h3>
    						<p v-if="action.description"><small>{{ action.description }}</small></p>
    					</div>
    				</li>
    			</ul>
    		</div>
		</div>
	</div>
</template>
<script>
/**
 * Next Actions module is used to create a page of possible actions that the user can take next.
 * @class NextActions
 * @prop {array} actionsList - Used to set the list of possible actions
 * @since 0.0.4
 */

export default {
	name: 'next-actions',
	props: {
		actionsList: {
			default: []
		}
	},
	methods: {
		/**
		 * To emit the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof NextActions
		 * @version 0.0.4
		 */
		emitFunction (functionName, params) {
			this.$emit('runFunction', functionName, params)
		}
	}
}
</script>


// WEBPACK FOOTER //
// NextActions.vue?15da173e